import {Component, Fragment} from 'react'
import PropTypes from 'prop-types'

import api from '../../../../api.js'
import ClearanceManager from '../../../components/Clearance/ClearanceManager.jsx'

import './ClearanceQuestion.scss'

const answers = {
  yes: 'yes',
  no: 'no',
}

/**
 * Question fermée posée dans le tunnel d'inscription : la saisie des habilitations n'est
 * proposée que si le consultant répond « Oui ». La réponse elle-même n'est pas persistée,
 * seules les habilitations créées le sont (via la même API que la fiche profil).
 */
export default class ClearanceQuestion extends Component {
  static propTypes = {
    freelance: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      answer: null,
    }
  }

  componentDidMount() {
    this.initAnswer()
  }

  // Si des habilitations ont déjà été déclarées (retour en arrière dans le tunnel, saisie
  // faite par un BM), on ouvre directement le bloc plutôt que de repartir sans réponse.
  initAnswer = async () => {
    try {
      const response = await api.freelanceClearances.getAll(null, {freelance: this.props.freelance.id})
      this.setState({answer: response.data.length > 0 ? answers.yes : null})
    } catch (e) {
      console.warn(e)
    } finally {
      this.setState({loading: false})
    }
  }

  handleAnswer = (answer) => {
    this.setState({answer})
  }

  renderAnswerButton = (answer, label) => (
    <button
      type="button"
      onClick={() => this.handleAnswer(answer)}
      className={`btn btn-${this.state.answer !== answer ? 'outline-' : ''}secondary`}
    >
      {label}
    </button>
  )

  render() {
    const {loading, answer} = this.state

    // On n'affiche la question qu'une fois les habilitations existantes connues, pour éviter
    // d'afficher un bloc sans réponse puis de le rouvrir dans la foulée.
    if (loading) {
      return null
    }

    return (
      <div className="clearance-question mt-5">
        <h4 className="text-center">
          Avez-vous une habilitation défense / sécurité ou nucléaire à déclarer ?
        </h4>
        <p className="text-center text-muted">
          Question facultative : vous pourrez toujours renseigner ou modifier vos habilitations
          plus tard depuis votre profil.
        </p>

        <div className="clearance-question-answers">
          {this.renderAnswerButton(answers.yes, 'Oui')}
          {this.renderAnswerButton(answers.no, 'Non')}
        </div>

        {answer === answers.yes && (
          <ClearanceManager
            freelanceId={this.props.freelance.id}
            emptyText={<Fragment>
              Aucune habilitation n&apos;a encore été renseignée.
              Utilisez le formulaire ci-dessus pour en ajouter une.
            </Fragment>}
          />
        )}
      </div>
    )
  }
}
